import { HoverCardWithIcon } from '@/common/components/shared/hover-card/HoverCardWithIcon';

export const TooltipHiringSource = () => (
  <HoverCardWithIcon position="top">
    Select &ldquo;Sourcing&rdquo; if the recruiter scouted, &ldquo;Job Posting&rdquo; if the employee applied by
    him/herself.
  </HoverCardWithIcon>
);
